<template>
   <div id="static-page-wrapper">
      <div class="container">
         <div class="content-wrapper">
            <aside class="sidebar-menu">
               <nav class="sticky-nav">
                  <a
                     v-for="section in sections"
                     :key="section.id"
                     :href="'#' + section.id"
                     class="nav-item"
                     :class="{ active: activeSection === section.id, alreadyRead: section.read }"
                     @click.prevent="scrollToSection(section.id)">
                     <!-- <template v-if="section.read">
                        <inline-svg v-if="activeSection === section.id" :key="`${section.id}-white`" class="check_white" :src="require('@/assets/img/check_white.svg')" width="16" height="16" />
                        <inline-svg v-else :key="`${section.id}-gray`" class="check_gray" :src="require('@/assets/img/check_gray.svg')" width="16" height="16" />
                     </template> -->
                     <!-- <span v-else class="tick-icon-placeholder"></span> -->

                     {{ section.label }}
                  </a>
               </nav>
            </aside>

            <div class="page-content">
               <section id="dsgvo" class="privacy-section">
                  <h2>A. Datenschutzerklärung nach der DSGVO</h2>

                  <h3 id="verantwortlicher">I. Name und Anschrift des Verantwortlichen</h3>
                  <p>
                     Der Verantwortliche im Sinne der Datenschutz-Grundverordnung und anderer nationaler Datenschutzgesetze der Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen ist
                     die:
                  </p>
                  <p>
                     GTS Global Travel Services GmbH<br />
                     Geschäftsführer Herr Serkan Yildiz<br />
                     Stresemannstr. 342, 22761 Hamburg, Deutschland<br />
                     Tel.: <a href="tel:+4940226138372">+49 40 226138372</a><br />
                     Fax: +49 40 87 96 99 89<br />
                     E-Mail: <a href="mailto:info@gtsfly.de">info@gtsfly.de</a><br />
                     Website: <a href="https://www.gtsfly.de" target="_blank" rel="noopener noreferrer">www.gtsfly.de</a>
                  </p>

                  <h3 id="datenschutzbeauftragter">II. Name und Anschrift des Datenschutzbeauftragten</h3>
                  <p>Ein Datenschutzbeauftragter ist derzeit nicht bestellt, da keine gesetzliche Verpflichtung besteht.</p>

                  <h3 id="datenverarbeitung">III. Allgemeines zur Datenverarbeitung</h3>
                  <h4>1. Umfang der Verarbeitung personenbezogener Daten</h4>
                  <p>
                     Wir verarbeiten personenbezogene Daten unserer Nutzer grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen
                     erforderlich ist. Die Verarbeitung personenbezogener Daten unserer Nutzer erfolgt regelmäßig nur nach Einwilligung des Nutzers. Eine Ausnahme gilt in solchen Fällen, in denen eine
                     vorherige Einholung einer Einwilligung aus tatsächlichen Gründen nicht möglich ist und die Verarbeitung der Daten durch gesetzliche Vorschriften gestattet ist.
                  </p>
                  <h4>2. Rechtsgrundlage für die Verarbeitung personenbezogener Daten</h4>
                  <p>
                     Soweit wir für Verarbeitungsvorgänge personenbezogener Daten eine Einwilligung der betroffenen Person einholen, dient Art. 6 Abs. 1 lit. a EU-Datenschutzgrundverordnung (DSGVO)
                     als Rechtsgrundlage. Bei der Verarbeitung von personenbezogenen Daten, die zur Erfüllung eines Vertrages, dessen Vertragspartei die betroffene Person ist, erforderlich ist, dient
                     Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen erforderlich sind. Soweit eine
                     Verarbeitung personenbezogener Daten zur Erfüllung einer rechtlichen Verpflichtung erforderlich ist, der unser Unternehmen unterliegt, dient Art. 6 Abs. 1 lit. c DSGVO als
                     Rechtsgrundlage. Für den Fall, dass lebenswichtige Interessen der betroffenen Person oder einer anderen natürlichen Person eine Verarbeitung personenbezogener Daten erforderlich
                     machen, dient Art. 6 Abs. 1 lit. d DSGVO als Rechtsgrundlage. Ist die Verarbeitung zur Wahrung eines berechtigten Interesses unseres Unternehmens oder eines Dritten erforderlich
                     und überwiegen die Interessen, Grundrechte und Grundfreiheiten des Betroffenen das erstgenannte Interesse nicht, so dient Art. 6 Abs. 1 lit. f DSGVO als Rechtsgrundlage für die
                     Verarbeitung.
                  </p>
                  <h4>3. Datenlöschung und Speicherdauer</h4>
                  <p>
                     Die personenbezogenen Daten der betroffenen Person werden gelöscht oder gesperrt, sobald der Zweck der Speicherung entfällt. Eine Speicherung kann darüber hinaus erfolgen, wenn
                     dies durch den europäischen oder nationalen Gesetzgeber in unionsrechtlichen Verordnungen, Gesetzen oder sonstigen Vorschriften, denen der Verantwortliche unterliegt, vorgesehen
                     wurde. Eine Sperrung oder Löschung der Daten erfolgt auch dann, wenn eine durch die genannten Normen vorgeschriebene Speicherfrist abläuft, es sei denn, dass eine Erforderlichkeit
                     zur weiteren Speicherung der Daten für einen Vertragsabschluss oder eine Vertragserfüllung besteht.
                  </p>

                  <h4>4. B2B-Plattformbetrieb, Buchungen und Consolidator-Rolle</h4>
                  <p>
                     GTS betreibt eine B2B-Buchungs- und Vermittlungsplattform. Im Rahmen der Nutzung verarbeitet GTS personenbezogene Daten von Endkunden (z. B. Namen, Kontaktdaten, Reisedaten), die
                     durch Vertragspartner übermittelt werden. Die Verarbeitung erfolgt zur Durchführung von Buchungen, Abrechnungen (einschließlich BSP/IATA oder Direktabrechnung mit
                     Fluggesellschaften) und zur Erfüllung vertraglicher Pflichten (Art. 6 Abs. 1 lit. b DSGVO).
                  </p>

                  <h4>5. API-, IBE- und White-Label-Anbindungen</h4>
                  <p>
                     Bei Nutzung von API-, IBE- oder White-Label-Lösungen stellt GTS technische Schnittstellen zur Verfügung, über die Vertragspartner personenbezogene Daten von Endkunden verarbeiten
                     oder an angebundene Systeme übermitteln können. GTS verarbeitet diese Daten im Rahmen der Bereitstellung der Plattform als eigenständig Verantwortlicher gemäß Art. 4 Nr. 7 DSGVO.
                     Der Vertragspartner bleibt dafür verantwortlich, dass die Verarbeitung und Übermittlung der Endkundendaten datenschutzrechtlich zulässig ist und die erforderlichen
                     Informationspflichten gegenüber Endkunden erfüllt werden. Die Verarbeitung erfolgt zur Durchführung der Buchungen, zur technischen Abwicklung sowie zur Sicherstellung des
                     ordnungsgemäßen Betriebs der angebundenen Systeme auf Grundlage von Art. 6 Abs. 1 lit. b und lit. f DSGVO.
                  </p>

                  <h3 id="logfiles">IV. Bereitstellung der Website und Erstellung von Logfiles</h3>

                  <h4>1. Beschreibung und Umfang der Datenverarbeitung</h4>
                  <p>Bei jedem Aufruf unserer Internetseite erfasst unser System automatisiert Daten und Informationen vom Computersystem des aufrufenden Rechners.</p>
                  <p>Folgende Daten werden hierbei erhoben:</p>
                  <ul>
                     <li>Informationen über den Browsertyp und die verwendete Version</li>
                     <li>Das Betriebssystem des Nutzers</li>
                     <li>Den Internet-Service-Provider des Nutzers</li>
                     <li>Die IP-Adresse des Nutzers</li>
                     <li>Datum und Uhrzeit des Zugriffs</li>
                     <li>Websites, von denen das System des Nutzers auf unsere Internetseite gelangt</li>
                     <li>Websites, die vom System des Nutzers über unsere Website aufgerufen werden</li>
                  </ul>
                  <p>
                     Die Daten werden ebenfalls in den Logfiles unseres Systems gespeichert. Eine Speicherung dieser Daten zusammen mit anderen personenbezogenen Daten des Nutzers findet nicht statt.
                  </p>

                  <h4>2. Rechtsgrundlage für die Datenverarbeitung</h4>
                  <p>Rechtsgrundlage für die vorübergehende Speicherung der Daten und der Logfiles ist Art. 6 Abs. 1 lit. f DSGVO.</p>

                  <h4>3. Zweck der Datenverarbeitung</h4>
                  <p>
                     Die vorübergehende Speicherung der IP-Adresse durch das System ist notwendig, um eine Auslieferung der Website an den Rechner des Nutzers zu ermöglichen. Hierfür muss die
                     IP-Adresse des Nutzers für die Dauer der Sitzung gespeichert bleiben. Die Speicherung in Logfiles erfolgt, um die Funktionsfähigkeit der Website sicherzustellen. Zudem dienen uns
                     die Daten zur Optimierung der Website und zur Sicherstellung der Sicherheit unserer informationstechnischen Systeme. Eine Auswertung der Daten zu Marketingzwecken findet in diesem
                     Zusammenhang nicht statt. In diesen Zwecken liegt auch unser berechtigtes Interesse an der Datenverarbeitung nach Art. 6 Abs. 1 lit. f DSGVO.
                  </p>

                  <h4>4. Dauer der Speicherung</h4>
                  <p>
                     Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind. Im Falle der Erfassung der Daten zur Bereitstellung der Website
                     ist dies der Fall, wenn die jeweilige Sitzung beendet ist. Im Falle der Speicherung der Daten in Logfiles ist dies nach spätestens sieben Tagen der Fall. Eine darüberhinausgehende
                     Speicherung ist möglich. In diesem Fall werden die IP-Adressen der Nutzer gelöscht oder verfremdet, sodass eine Zuordnung des aufrufenden Clients nicht mehr möglich ist.
                  </p>

                  <h4>5. Widerspruchs- und Beseitigungsmöglichkeit</h4>
                  <p>
                     Die Erfassung der Daten zur Bereitstellung der Website und die Speicherung der Daten in Logfiles ist für den Betrieb der Internetseite zwingend erforderlich. Es besteht folglich
                     seitens des Nutzers keine Widerspruchsmöglichkeit.
                  </p>

                  <h4>6. Sicherheit- und Zugriffslogging</h4>
                  <p>
                     Zur Gewährleistung der IT- und Datensicherheit sowie zur Verhinderung und Aufklärung von Missbrauch verarbeitet GTS zusätzlich sicherheitsrelevante Protokolldaten. Hierzu gehören
                     insbesondere Login-Zeitpunkte, Zugriffsversuche, Account-Aktivitäten sowie sicherheitsrelevante Systemereignisse. Die Verarbeitung erfolgt ausschließlich zu Sicherheitszwecken auf
                     Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Eine Nutzung dieser Daten zu Marketing- oder Analysezwecken findet nicht statt.
                  </p>

                  <h3 id="cookies">V. Verwendung von Cookies</h3>

                  <h4>a) Beschreibung und Umfang der Datenverarbeitung</h4>
                  <p>
                     Unsere Webseite verwendet Cookies. Bei Cookies handelt es sich um Textdateien, die im Internetbrowser bzw. vom Internetbrowser auf dem Computersystem des Nutzers gespeichert
                     werden. Ruft ein Nutzer eine Website auf, so kann ein Cookie auf dem Betriebssystem des Nutzers gespeichert werden. Dieser Cookie enthält eine charakteristische Zeichenfolge, die
                     eine eindeutige Identifizierung des Browsers beim erneuten Aufrufen der Website ermöglicht. Wir setzen Cookies ein, um unsere Website nutzerfreundlicher zu gestalten. Einige
                     Elemente unserer Internetseite erfordern es, dass der aufrufende Browser auch nach einem Seitenwechsel identifiziert werden kann. In den Cookies werden dabei folgende Daten
                     gespeichert und übermittelt:
                  </p>
                  <ul>
                     <li>Spracheinstellungen</li>
                     <li>Artikel in einem Warenkorb</li>
                     <li>Log-In-Informationen</li>
                  </ul>
                  <p>Wir verwenden auf unserer Website darüber hinaus Cookies, die eine Analyse des Surfverhaltens der Nutzer ermöglichen. Auf diese Weise können folgende Daten übermittelt werden:</p>
                  <ul>
                     <li>Eingegebene Suchbegriffe</li>
                     <li>Häufigkeit von Seitenaufrufen</li>
                     <li>Inanspruchnahme von Website-Funktionen</li>
                  </ul>
                  <p>
                     Die auf diese Weise erhobenen Daten der Nutzer werden durch technische Vorkehrungen pseudonymisiert. Daher ist eine Zuordnung der Daten zum aufrufenden Nutzer nicht mehr möglich.
                     Die Daten werden nicht gemeinsam mit sonstigen personenbezogenen Daten der Nutzer gespeichert. Beim Aufruf unserer Website werden die Nutzer durch ein Infobanner über die
                     Verwendung von Cookies zu Analysezwecken informiert und auf diese Datenschutzerklärung verwiesen. Es erfolgt in diesem Zusammenhang auch ein Hinweis darauf, wie die Speicherung
                     von Cookies in den Browsereinstellungen unterbunden werden kann.
                  </p>

                  <h4>b) Rechtsgrundlage für die Datenverarbeitung</h4>
                  <p>
                     Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten unter Verwendung technisch notwendiger Cookies ist Art. 6 Abs. 1 lit. f DSGVO in Verbindung mit § 25 Abs. 2 Nr. 2
                     TTDSG. Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten unter Verwendung von Cookies und vergleichbaren Technologien, die nicht technisch notwendig sind,
                     insbesondere zu Analyse- oder Statistikzwecken, ist bei Vorliegen einer entsprechenden Einwilligung des Nutzers Art. 6 Abs. 1 lit. a DSGVO in Verbindung mit § 25 Abs. 1 TTDSG.
                  </p>

                  <h4>c) Zweck der Datenverarbeitung</h4>
                  <p>
                     Der Zweck der Verwendung technisch notwendiger Cookies ist, die Nutzung von Websites für die Nutzer zu vereinfachen. Einige Funktionen unserer Internetseite können ohne den
                     Einsatz von Cookies nicht angeboten werden. Für diese ist es erforderlich, dass der Browser auch nach einem Seitenwechsel wiedererkannt wird. Die durch technisch notwendige
                     Cookies erhobenen Nutzerdaten werden nicht zur Erstellung von Nutzerprofilen verwendet. Die Verwendung von Analyse- und Statistik-Cookies erfolgt zu dem Zweck, die Qualität
                     unserer Website und ihre Inhalte zu verbessern. Durch die Analyse-Cookies erfahren wir, wie die Website genutzt wird und können so unser Angebot stetig optimieren.
                  </p>

                  <h4>d) Dauer der Speicherung, Widerspruchs- und Beseitigungsmöglichkeit</h4>
                  <p>
                     Cookies werden auf dem Rechner des Nutzers gespeichert und von diesem an unsere Seite übermittelt. Daher haben Nutzer auch die volle Kontrolle über die Verwendung von Cookies.
                     Durch eine Änderung der Einstellungen in ihrem Internetbrowser können sie die Übertragung von Cookies deaktivieren oder einschränken. Bereits gespeicherte Cookies können jederzeit
                     gelöscht werden. Dies kann auch automatisiert erfolgen. Werden Cookies für unsere Website deaktiviert, können möglicherweise nicht mehr alle Funktionen der Website vollumfänglich
                     genutzt werden. Soweit Cookies auf Grundlage einer Einwilligung eingesetzt werden, kann diese Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen werden.
                  </p>

                  <h3 id="registrierung">VI. Registrierung</h3>

                  <h4>1. Beschreibung und Umfang der Datenverarbeitung</h4>
                  <p>
                     Auf unserer Internetseite bieten wir Nutzern die Möglichkeit, sich unter Angabe personenbezogener Daten zu registrieren. Die Daten werden dabei in eine Eingabemaske eingegeben, an
                     uns übermittelt und gespeichert. Eine Weitergabe der Daten an unbefugte Dritte findet nicht statt.
                  </p>
                  <p>Folgende Daten werden im Rahmen des Registrierungsprozesses erhoben:</p>
                  <p>Name, Anschrift, Telefonnummer, E-Mail-Adresse.</p>
                  <p>Im Zeitpunkt der Registrierung werden zudem folgende Daten gespeichert:</p>
                  <ul>
                     <li>die IP-Adresse des Nutzers</li>
                     <li>Datum und Uhrzeit der Registrierung</li>
                  </ul>
                  <p>
                     Die Verarbeitung der im Rahmen der Registrierung erhobenen Daten erfolgt zur Anbahnung, Begründung, Durchführung und Abwicklung der vertraglichen Geschäftsbeziehung mit dem
                     registrierenden Unternehmen. Soweit für einzelne Verarbeitungsvorgänge eine Einwilligung erforderlich ist, wird diese gesondert eingeholt.
                  </p>
                  <p>
                     Zur Absicherung der Nutzerkonten setzt GTS im Rahmen des Registrierungs- und Login-Prozesses eine Zwei-Faktor-Authentifizierung (2FA) ein. Hierbei werden zeitbasierte
                     Sicherheits-Token sowie technische Metadaten verarbeitet. Die Verarbeitung dieser Daten erfolgt ausschließlich zu Sicherheitszwecken.
                  </p>

                  <h4>2. Rechtsgrundlage für die Datenverarbeitung</h4>
                  <p>
                     Rechtsgrundlage für die Verarbeitung der Daten ist bei Vorliegen einer Einwilligung des Nutzers Art. 6 Abs. 1 lit. a DSGVO. Dient die Registrierung der Erfüllung eines Vertrages,
                     dessen Vertragspartei der Nutzer ist oder der Durchführung vorvertraglicher Maßnahmen, so ist zusätzliche Rechtsgrundlage für die Verarbeitung der Daten Art. 6 Abs. 1 lit. b
                     DSGVO.
                  </p>
                  <p>
                     Die Verarbeitung der im Rahmen der Zwei-Faktor-Authentifizierung anfallenden Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Sicherheit
                     der Systeme).
                  </p>

                  <h4>3. Zweck der Datenverarbeitung</h4>
                  <p>
                     Eine Registrierung des Nutzers ist für das Bereithalten bestimmter Inhalte und Leistungen auf unserer Website sowie für die Nutzung der Buchungs- und Vermittlungsplattform
                     erforderlich. Die Registrierung dient der Begründung, Durchführung und Abwicklung einer Geschäftsbeziehung. Das sich registrierende Unternehmen stellt sich mit der Registrierung
                     gegenüber GTS vor.
                  </p>
                  <p>Die Zwei-Faktor-Authentifizierung dient der Sicherung der Nutzerkonten sowie der Verhinderung unbefugter Zugriffe und missbräuchlicher Nutzungen.</p>

                  <h4>4. Dauer der Speicherung</h4>
                  <p>
                     Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind. Dies ist für die während des Registrierungsvorgangs erhobenen
                     Daten der Fall, wenn die Registrierung auf unserer Internetseite aufgehoben oder abgeändert wird. Daten, die im Rahmen der Zwei-Faktor-Authentifizierung verarbeitet werden, werden
                     ausschließlich für die Dauer des jeweiligen Authentifizierungs- bzw. Sicherheitszwecks gespeichert.
                  </p>

                  <h4>5. Widerspruchs- und Beseitigungsmöglichkeit</h4>
                  <p>
                     Als Nutzer haben Sie jederzeit die Möglichkeit, die Registrierung aufzulösen. Die über Sie gespeicherten Daten können Sie jederzeit abändern lassen. Die Nutzung der
                     Zwei-Faktor-Authentifizierung ist Bestandteil der Sicherheitsmaßnahmen für Nutzerkonten; eine Deaktivierung ist nur nach Maßgabe der vertraglichen Vereinbarungen möglich.
                  </p>

                  <h3 id="email-kontakt">VII. E-Mail-Kontakt</h3>
                  <h4>1. Beschreibung und Umfang der Datenverarbeitung</h4>
                  <p>
                     Eine Kontaktaufnahme über die bereitgestellte E-Mail-Adresse ist möglich. In diesem Fall werden die mit der E-Mail übermittelten personenbezogenen Daten des Nutzers gespeichert.
                     Es erfolgt in diesem Zusammenhang keine Weitergabe der Daten an Dritte. Die Daten werden ausschließlich für die Verarbeitung der Konversation verwendet.
                  </p>

                  <h4>2. Rechtsgrundlage für die Datenverarbeitung</h4>
                  <p>
                     Rechtsgrundlage für die Verarbeitung der Daten, die im Zuge einer Übersendung einer E-Mail übermittelt werden, ist Art. 6 Abs. 1 lit. f DSGVO. Zielt der E-Mail-Kontakt auf den
                     Abschluss eines Vertrages ab, so ist zusätzliche Rechtsgrundlage für die Verarbeitung Art. 6 Abs. 1 lit. b DSGVO.
                  </p>

                  <h4>3. Zweck der Datenverarbeitung</h4>
                  <p>Im Falle einer Kontaktaufnahme per E-Mail liegt hieran auch das erforderliche berechtigte Interesse an der Verarbeitung der Daten.</p>

                  <h4>4. Dauer der Speicherung</h4>
                  <p>
                     Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind. Für die personenbezogenen Daten die per E-Mail übersandt wurden,
                     ist dies dann der Fall, wenn die jeweilige Konversation mit dem Nutzer beendet ist. Beendet ist die Konversation dann, wenn sich aus den Umständen entnehmen lässt, dass der
                     betroffene Sachverhalt abschließend geklärt ist. Die während des Absendevorgangs zusätzlich erhobenen personenbezogenen Daten werden spätestens nach einer Frist von sieben Tagen
                     gelöscht.
                  </p>

                  <h4>5. Widerspruchs- und Beseitigungsmöglichkeit</h4>
                  <p>
                     Der Nutzer hat jederzeit die Möglichkeit, seine Einwilligung zur Verarbeitung der personenbezogenen Daten zu widerrufen. Nimmt der Nutzer per E-mail Kontakt mit uns auf, so kann
                     er der Speicherung seiner personenbezogenen Daten jederzeit widersprechen. In einem solchen Fall kann die Konversation nicht fortgeführt werden. Der Widerruf der Einwilligung und
                     der Widerruf der Speicherung kann per E-mail an <a href="mailto:info@gtsfly.de">info@gtsfly.de</a> erklärt werden. Alle personenbezogenen Daten, die im Zuge der Kontaktaufnahme
                     gespeichert wurden, werden in diesem Fall gelöscht.
                  </p>

                  <h3 id="matomo">VIII. Webanalyse durch Matomo (ehemals PIWIK)</h3>
                  <h4>1. Umfang der Verarbeitung personenbezogener Daten</h4>
                  <p>
                     Wir nutzen auf unserer Website das Open-Source-Webanalyse-Tool Matomo zur Analyse des Nutzungsverhaltens unserer Websitebesucher. Matomo verwendet Cookies und vergleichbare
                     Technologien, die auf dem Endgerät der Nutzer gespeichert werden und eine Analyse der Benutzung der Website ermöglichen.
                  </p>
                  <p>Werden Einzelseiten unserer Website aufgerufen, können dabei insbesondere folgende Daten verarbeitet werden:</p>
                  <ul>
                     <li>anonymisierte IP-Adresse des aufrufenden Systems</li>
                     <li>die aufgerufene Webseite</li>
                     <li>die Website, von der der Nutzer auf die aufgerufene Webseite gelangt ist (Referrer)</li>
                     <li>die Unterseiten, die von der aufgerufenen Webseite aus aufgerufen werden</li>
                     <li>die Verweildauer auf der Webseite</li>
                     <li>die Häufigkeit des Aufrufs der Webseite</li>
                  </ul>
                  <p>
                     Die durch Matomo erzeugten Informationen werden ausschließlich auf unseren eigenen Servern gespeichert. Eine Weitergabe der Daten an Dritte erfolgt nicht. Die IP-Adresse wird vor
                     der Speicherung anonymisiert, sodass eine direkte Personenbeziehbarkeit ausgeschlossen ist.
                  </p>

                  <h4>2. Rechtsgrundlage für die Verarbeitung personenbezogener Daten</h4>
                  <p>
                     Die Verarbeitung personenbezogener Daten im Rahmen der Nutzung von Matomo erfolgt ausschließlich auf Grundlage einer Einwilligung des Nutzers gemäß Art. 6 Abs. 1 lit. a DSGVO in
                     Verbindung mit § 25 Abs. 1 TTDSG, soweit Cookies oder vergleichbare Technologien eingesetzt werden. Ohne eine entsprechende Einwilligung findet keine Verarbeitung von Analyse-
                     oder Statistikdaten statt.
                  </p>

                  <h4>3. Zweck der Datenverarbeitung</h4>
                  <p>
                     Die Verarbeitung der personenbezogenen Daten der Nutzer ermöglicht uns eine Analyse der Nutzung unserer Website. Durch die Auswertung der gewonnenen Daten sind wir in der Lage,
                     Informationen über die Nutzung der einzelnen Komponenten unserer Website zusammenzustellen und unser Online-Angebot sowie dessen Nutzerfreundlichkeit kontinuierlich zu verbessern.
                  </p>

                  <h4>4. Dauer der Speicherung</h4>
                  <p>
                     Die im Rahmen der Webanalyse erhobenen Daten werden gelöscht, sobald sie für die genannten Zwecke nicht mehr erforderlich sind. Im Übrigen richten sich die Speicherfristen nach
                     den Einstellungen des eingesetzten Analyse-Tools. Anonymisierte Auswertungsdaten können über einen längeren Zeitraum gespeichert werden, da ein Personenbezug nicht mehr besteht.
                  </p>

                  <h4>5. Widerspruchs- und Beseitigungsmöglichkeit</h4>
                  <p>
                     Die Nutzung von Matomo erfolgt ausschließlich auf Grundlage einer Einwilligung. Diese Einwilligung kann jederzeit mit Wirkung für die Zukunft widerrufen werden. Der Widerruf kann
                     über die Einstellungen des eingesetzten Cookie-Banners erfolgen. Weitere Informationen zur Datenverarbeitung durch Matomo finden Sie unter folgendem Link:
                     <a href="https://matomo.org/docs/privacy/" target="_blank" rel="noopener noreferrer">https://matomo.org/docs/privacy/</a>.
                  </p>

                  <h3 id="rechte">IX. Rechte der betroffenen Person</h3>
                  <p>Werden personenbezogene Daten von Ihnen verarbeitet, sind Sie Betroffener i.S.d. DSGVO und es stehen Ihnen folgende Rechte gegenüber dem Verantwortlichen zu:</p>

                  <h4>1. Auskunftsrecht</h4>
                  <p>
                     Sie können von dem Verantwortlichen eine Bestätigung darüber verlangen, ob personenbezogene Daten, die Sie betreffen, von uns verarbeitet werden. Liegt eine solche Verarbeitung
                     vor, können Sie von dem Verantwortlichen über folgende Informationen Auskunft verlangen:
                  </p>
                  <ul>
                     <li>die Zwecke, zu denen die personenbezogenen Daten verarbeitet werden;</li>
                     <li>die Kategorien von personenbezogenen Daten, welche verarbeitet werden;</li>
                     <li>die Empfänger bzw. die Kategorien von Empfängern, gegenüber denen die Sie betreffenden personenbezogenen Daten offengelegt wurden oder noch offengelegt werden;</li>
                     <li>
                        die geplante Dauer der Speicherung der Sie betreffenden personenbezogenen Daten oder, falls konkrete Angaben hierzu nicht möglich sind, Kriterien für die Festlegung der
                        Speicherdauer;
                     </li>
                     <li>
                        das Bestehen eines Rechts auf Berichtigung oder Löschung der Sie betreffenden personenbezogenen Daten, eines Rechts auf Einschränkung der Verarbeitung durch den
                        Verantwortlichen oder eines Widerspruchsrechts gegen diese Verarbeitung;
                     </li>
                     <li>das Bestehen eines Beschwerderechts bei einer Aufsichtsbehörde;</li>
                     <li>alle verfügbaren Informationen über die Herkunft der Daten, wenn die personenbezogenen Daten nicht bei der betroffenen Person erhoben werden;</li>
                     <li>
                        das Bestehen einer automatisierten Entscheidungsfindung einschließlich Profiling gemäß Art. 22 Abs. 1 und 4 DSGVO und – zumindest in diesen Fällen – aussagekräftige
                        Informationen über die involvierte Logik sowie die Tragweite und die angestrebten Auswirkungen einer derartigen Verarbeitung für die betroffene Person.
                     </li>
                  </ul>
                  <p>
                     Ihnen steht das Recht zu, Auskunft darüber zu verlangen, ob die Sie betreffenden personenbezogenen Daten in ein Drittland oder an eine internationale Organisation übermittelt
                     werden. In diesem Zusammenhang können Sie verlangen, über die geeigneten Garantien gem. Art. 46 DSGVO im Zusammenhang mit der Übermittlung unterrichtet zu werden.
                  </p>

                  <h4>2. Recht auf Berichtigung</h4>
                  <p>
                     Sie haben ein Recht auf Berichtigung und/oder Vervollständigung gegenüber dem Verantwortlichen, sofern die verarbeiteten personenbezogenen Daten, die Sie betreffen, unrichtig oder
                     unvollständig sind. Der Verantwortliche hat die Berichtigung unverzüglich vorzunehmen.
                  </p>

                  <h4>3. Recht auf Einschränkung der Verarbeitung</h4>
                  <p>Unter den folgenden Voraussetzungen können Sie die Einschränkung der Verarbeitung der Sie betreffenden personenbezogenen Daten verlangen:</p>
                  <ul>
                     <li>
                        wenn Sie die Richtigkeit der Sie betreffenden personenbezogenen für eine Dauer bestreiten, die es dem Verantwortlichen ermöglicht, die Richtigkeit der personenbezogenen Daten
                        zu überprüfen;
                     </li>
                     <li>
                        die Verarbeitung unrechtmäßig ist und Sie die Löschung der personenbezogenen Daten ablehnen und stattdessen die Einschränkung der Nutzung der personenbezogenen Daten verlangen;
                     </li>
                     <li>
                        der Verantwortliche die personenbezogenen Daten für die Zwecke der Verarbeitung nicht länger benötigt, Sie diese jedoch zur Geltendmachung, Ausübung oder Verteidigung von
                        Rechtsansprüchen benötigen, oder
                     </li>
                     <li>
                        wenn Sie Widerspruch gegen die Verarbeitung gemäß Art. 21 Abs. 1 DSGVO eingelegt haben und noch nicht feststeht, ob die berechtigten Gründe des Verantwortlichen gegenüber Ihren
                        Gründen überwiegen.
                     </li>
                  </ul>
                  <p>
                     Wurde die Verarbeitung der Sie betreffenden personenbezogenen Daten eingeschränkt, dürfen diese Daten – von ihrer Speicherung abgesehen – nur mit Ihrer Einwilligung oder zur
                     Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen oder zum Schutz der Rechte einer anderen natürlichen oder juristischen Person oder aus Gründen eines wichtigen
                     öffentlichen Interesses der Union oder eines Mitgliedstaats verarbeitet werden. Wurde die Einschränkung der Verarbeitung nach den o.g. Voraussetzungen eingeschränkt, werden Sie
                     von dem Verantwortlichen unterrichtet bevor die Einschränkung aufgehoben wird.
                  </p>

                  <h4>4. Recht auf Löschung</h4>
                  <h4>a) Löschungspflicht</h4>
                  <p>
                     Sie können von dem Verantwortlichen verlangen, dass die Sie betreffenden personenbezogenen Daten unverzüglich gelöscht werden, und der Verantwortliche ist verpflichtet, diese
                     Daten unverzüglich zu löschen, sofern einer der folgenden Gründe zutrifft:
                  </p>
                  <ul>
                     <li>Die Sie betreffenden personenbezogenen Daten sind für die Zwecke, für die sie erhoben oder auf sonstige Weise verarbeitet wurden, nicht mehr notwendig.</li>
                     <li>
                        Sie widerrufen Ihre Einwilligung, auf die sich die Verarbeitung gem. Art. 6 Abs. 1 lit. a oder Art. 9 Abs. 2 lit. a DSGVO stützte, und es fehlt an einer anderweitigen
                        Rechtsgrundlage für die Verarbeitung.
                     </li>
                     <li>
                        Sie legen gem. Art. 21 Abs. 1 DSGVO Widerspruch gegen die Verarbeitung ein und es liegen keine vorrangigen berechtigten Gründe für die Verarbeitung vor, oder Sie legen gem.
                        Art. 21 Abs. 2 DSGVO Widerspruch gegen die Verarbeitung ein.
                     </li>
                     <li>Die Sie betreffenden personenbezogenen Daten wurden unrechtmäßig verarbeitet.</li>
                     <li>
                        Die Löschung der Sie betreffenden personenbezogenen Daten ist zur Erfüllung einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten
                        erforderlich, dem der Verantwortliche unterliegt.
                     </li>
                     <li>Die Sie betreffenden personenbezogenen Daten wurden in Bezug auf angebotene Dienste der Informationsgesellschaft gemäß Art. 8 Abs. 1 DSGVO erhoben.</li>
                  </ul>

                  <h4>b) Information an Dritte</h4>
                  <p>
                     Hat der Verantwortliche die Sie betreffenden personenbezogenen Daten öffentlich gemacht und ist er gem. Art. 17 Abs. 1 DSGVO zu deren Löschung verpflichtet, so trifft er unter
                     Berücksichtigung der verfügbaren Technologie und der Implementierungskosten angemessene Maßnahmen, auch technischer Art, um für die Datenverarbeitung Verantwortliche, die die
                     personenbezogenen Daten verarbeiten, darüber zu informieren, dass Sie als betroffene Person von ihnen die Löschung aller Links zu diesen personenbezogenen Daten oder von Kopien
                     oder Replikationen dieser personenbezogenen Daten verlangt haben.
                  </p>

                  <h4>c) Ausnahmen</h4>
                  <p>Das Recht auf Löschung besteht nicht, soweit die Verarbeitung erforderlich ist</p>
                  <ul>
                     <li>zur Ausübung des Rechts auf freie Meinungsäußerung und Information;</li>
                     <li>
                        zur Erfüllung einer rechtlichen Verpflichtung, die die Verarbeitung nach dem Recht der Union oder der Mitgliedstaaten, dem der Verantwortliche unterliegt, erfordert, oder zur
                        Wahrnehmung einer Aufgabe, die im öffentlichen Interesse liegt oder in Ausübung öffentlicher Gewalt erfolgt, die dem Verantwortlichen übertragen wurde;
                     </li>
                     <li>aus Gründen des öffentlichen Interesses im Bereich der öffentlichen Gesundheit gemäß Art. 9 Abs. 2 lit. h und i sowie Art. 9 Abs. 3 DSGVO;</li>
                     <li>
                        für im öffentlichen Interesse liegende Archivzwecke, wissenschaftliche oder historische Forschungszwecke oder für statistische Zwecke gem. Art. 89 Abs. 1 DSGVO, soweit das
                        unter Abschnitt a) genannte Recht voraussichtlich die Verwirklichung der Ziele dieser Verarbeitung unmöglich macht oder ernsthaft beeinträchtigt, oder
                     </li>
                     <li>zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen</li>
                  </ul>

                  <h4>5. Recht auf Unterrichtung</h4>
                  <p>
                     Haben Sie das Recht auf Berichtigung, Löschung oder Einschränkung der Verarbeitung gegenüber dem Verantwortlichen geltend gemacht, ist dieser verpflichtet, allen Empfängern, denen
                     die Sie betreffenden personenbezogenen Daten offengelegt wurden, diese Berichtigung oder Löschung der Daten oder Einschränkung der Verarbeitung mitzuteilen, es sei denn, dies
                     erweist sich als unmöglich oder ist mit einem unverhältnismäßigen Aufwand verbunden. Ihnen steht gegenüber dem Verantwortlichen das Recht zu, über diese Empfänger unterrichtet zu
                     werden.
                  </p>

                  <h4>6. Recht auf Datenübertragbarkeit</h4>
                  <p>
                     Sie haben das Recht, die Sie betreffenden personenbezogenen Daten, die Sie dem Verantwortlichen bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren
                     Format zu erhalten. Außerdem haben Sie das Recht diese Daten einem anderen Verantwortlichen ohne Behinderung durch den Verantwortlichen, dem die personenbezogenen Daten
                     bereitgestellt wurden, zu übermitteln, sofern
                  </p>
                  <ul>
                     <li>die Verarbeitung auf einer Einwilligung gem. Art. 6 Abs. 1 lit. a DSGVO oder Art. 9 Abs. 2 lit. a DSGVO oder auf einem Vertrag gem. Art. 6 Abs. 1 lit. b DSGVO beruht und</li>
                     <li>die Verarbeitung mithilfe automatisierter Verfahren erfolgt.</li>
                  </ul>
                  <p>
                     In Ausübung dieses Rechts haben Sie ferner das Recht, zu erwirken, dass die Sie betreffenden personenbezogenen Daten direkt von einem Verantwortlichen einem anderen
                     Verantwortlichen übermittelt werden, soweit dies technisch machbar ist. Freiheiten und Rechte anderer Personen dürfen hierdurch nicht beeinträchtigt werden. Das Recht auf
                     Datenübertragbarkeit gilt nicht für eine Verarbeitung personenbezogener Daten, die für die Wahrnehmung einer Aufgabe erforderlich ist, die im öffentlichen Interesse liegt oder in
                     Ausübung öffentlicher Gewalt erfolgt, die dem Verantwortlichen übertragen wurde.
                  </p>

                  <h4>7. Widerspruchsrecht</h4>
                  <p>
                     Sie haben das Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten, die aufgrund von
                     Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt, Widerspruch einzulegen; dies gilt auch für ein auf diese Bestimmungen gestütztes Profiling. Der Verantwortliche verarbeitet die Sie
                     betreffenden personenbezogenen Daten nicht mehr, es sei denn, er kann zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten
                     überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen. Werden die Sie betreffenden personenbezogenen Daten verarbeitet, um
                     Direktwerbung zu betreiben, haben Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten zum Zwecke derartiger Werbung
                     einzulegen; dies gilt auch für das Profiling, soweit es mit solcher Direktwerbung in Verbindung steht. Widersprechen Sie der Verarbeitung für Zwecke der Direktwerbung, so werden
                     die Sie betreffenden personenbezogenen Daten nicht mehr für diese Zwecke verarbeitet. Sie haben die Möglichkeit, im Zusammenhang mit der Nutzung von Diensten der
                     Informationsgesellschaft – ungeachtet der Richtlinie 2002/58/EG – Ihr Widerspruchsrecht mittels automatisierter Verfahren auszuüben, bei denen technische Spezifikationen verwendet
                     werden.
                  </p>

                  <h4>8. Recht auf Widerruf der datenschutzrechtlichen Einwilligungserklärung</h4>
                  <p>
                     Sie haben das Recht, Ihre datenschutzrechtliche Einwilligungserklärung jederzeit zu widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der
                     Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.
                  </p>

                  <h4>9. Automatisierte Entscheidung im Einzelfall einschließlich Profiling</h4>
                  <p>
                     Sie haben das Recht, nicht einer ausschließlich auf einer automatisierten Verarbeitung, einschließlich Profiling, beruhenden Entscheidung unterworfen zu werden, die Ihnen
                     gegenüber rechtliche Wirkung entfaltet oder Sie in ähnlicher Weise erheblich beeinträchtigt. Dies gilt nicht, wenn die Entscheidung
                  </p>
                  <ul>
                     <li>für den Abschluss oder die Erfüllung eines Vertrags zwischen Ihnen und dem Verantwortlichen erforderlich ist,</li>
                     <li>
                        aufgrund von Rechtsvorschriften der Union oder der Mitgliedstaaten, denen der Verantwortliche unterliegt, zulässig ist und diese Rechtsvorschriften angemessene Maßnahmen zur
                        Wahrung Ihrer Rechte und Freiheiten sowie Ihrer berechtigten Interessen enthalten oder
                     </li>
                     <li>mit Ihrer ausdrücklichen Einwilligung erfolgt.</li>
                  </ul>
                  <p>
                     Allerdings dürfen diese Entscheidungen nicht auf besonderen Kategorien personenbezogener Daten nach Art. 9 Abs. 1 DSGVO beruhen, sofern nicht Art. 9 Abs. 2 lit. a oder g DSGVO
                     gilt und angemessene Maßnahmen zum Schutz der Rechte und Freiheiten sowie Ihrer berechtigten Interessen getroffen wurden. Hinsichtlich der in (1) und (3) genannten Fälle trifft
                     der Verantwortliche angemessene Maßnahmen, um die Rechte und Freiheiten sowie Ihre berechtigten Interessen zu wahren, wozu mindestens das Recht auf Erwirkung des Eingreifens einer
                     Person seitens des Verantwortlichen, auf Darlegung des eigenen Standpunkts und auf Anfechtung der Entscheidung gehört.
                  </p>

                  <h4>10. Recht auf Beschwerde bei einer Aufsichtsbehörde</h4>
                  <p>
                     Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs steht Ihnen das Recht auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem
                     Mitgliedstaat ihres Aufenthaltsorts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes, zu, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden
                     personenbezogenen Daten gegen die DSGVO verstößt. Die Aufsichtsbehörde, bei der die Beschwerde eingereicht wurde, unterrichtet den Beschwerdeführer über den Stand und die
                     Ergebnisse der Beschwerde einschließlich der Möglichkeit eines gerichtlichen Rechtsbehelfs nach Art. 78 DSGVO.
                  </p>
                  <p style="margin-top: 48px; text-align: left; color: #717171; font-size: 14px">Stand Januar 2026</p>
               </section>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
// import * as RestApi from "@/service/rest.api";
// import InlineSvg from "vue-inline-svg";
export default {
   name: "DatenschutzPage",
   components: {
      // InlineSvg,
   },
   data() {
      return {
         activeSection: "dsgvo",
         hasReachedTop: false,
         sections: [
            { id: "verantwortlicher", label: "I. Verantwortlicher", read: false },
            { id: "datenschutzbeauftragter", label: "II. Datenschutzbeauftragter", read: false },
            { id: "datenverarbeitung", label: "III. Datenverarbeitung", read: false },
            { id: "logfiles", label: "IV. Logfiles", read: false },
            { id: "cookies", label: "V. Cookies", read: false },
            { id: "registrierung", label: "VI. Registrierung", read: false },
            { id: "email-kontakt", label: "VII. Kontakt", read: false },
            { id: "matomo", label: "VIII. Matomo", read: false },
            { id: "rechte", label: "IX. Betroffenenrechte", read: false },
         ],
      };
   },
   mounted() {
      this.hasReachedTop = false;

      // 🧠 sayfa zaten en üstteyse manuel reset
      if (window.scrollY === 0) {
         this.sections.forEach((s) => (s.read = false));
         this.hasReachedTop = true;
      }

      window.addEventListener("scroll", this.onScroll);
   },

   beforeUnmount() {
      window.removeEventListener("scroll", this.onScroll);
   },
   methods: {
      scrollToSection(id) {
         const element = document.getElementById(id);
         if (element) {
            const offset = 120;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - offset;

            window.scrollTo({
               top: offsetPosition,
               behavior: "smooth",
            });
         }
      },
      onScroll() {
         // 🧼 en üste gelince reset
         if (window.scrollY === 0) {
            this.sections.forEach((s) => (s.read = false));
            this.hasReachedTop = true;
            return;
         }

         const pos = window.scrollY + window.innerHeight * 0.5;

         for (let i = this.sections.length - 1; i >= 0; i--) {
            const s = this.sections[i];
            const el = document.getElementById(s.id);

            if (el && el.offsetTop <= pos) {
               this.activeSection = s.id;
               if (!s.read) {
                  s.read = true;
               }
               break;
            }
         }
      },
   },
};
</script>

<style lang="scss" scoped>
.alreadyRead {
   color: #a1a1a1 !important;
   // color: #33b8ff !important;
}
.tick-icon {
   display: inline-block;
   width: 20px;
   height: 20px;
}

.tick-icon-placeholder {
   display: inline-block;
   width: 20px;
   height: 20px;
}

#static-page-wrapper {
   padding: 50px 24px 80px;
   min-height: 100vh;

   @media (max-width: 1024px) {
      padding: 100px 24px 64px;
   }

   .container {
      // max-width: 1440px;
      margin: 0 auto;
   }

   #page-header {
      margin: 0 0 48px;
      padding: 32px 48px;
      background: #fafafa;
      border-radius: 12px;

      .page-title {
         font-size: 32px;
         font-weight: 600;
         color: #222222;
         margin: 0;
         line-height: 1.25;

         @media (min-width: 768px) {
            font-size: 48px;
         }
      }
   }

   .content-wrapper {
      display: grid;
      grid-template-columns: 260px 1fr;
      gap: 64px;

      @media (max-width: 1024px) {
         grid-template-columns: 1fr;
         gap: 32px;
      }

      @media (max-width: 768px) {
         grid-template-columns: 1fr;
         gap: 0;
      }
   }

   .sidebar-menu {
      padding: 24px 0;

      @media (max-width: 1024px) {
         width: 100%;
         border-bottom: 1px solid #e5e5e5;
         padding-bottom: 24px;
      }

      @media (max-width: 768px) {
         display: none;
      }

      .sticky-nav {
         position: sticky;
         top: 116px;
         display: flex;
         flex-direction: column;
         gap: 4px;

         @media (max-width: 1024px) {
            position: static;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 8px;
         }

         .nav-item {
            padding: 8px 12px;
            font-size: 15px;
            color: #717171;
            text-decoration: none;
            border-radius: 8px;
            transition: all 0.2s ease;
            font-weight: 500;
            min-height: 38px;
            align-items: center;
            display: flex;
            gap: 0.25rem;

            &:hover {
               background: #f7f7f7;
               color: #222222;
            }

            &.active {
               background: #e1e1e1;
               background: #2f64b9;
               color: #222222;
               color: #fff !important;
               // font-weight: 600;
            }

            @media (max-width: 1024px) {
               padding: 6px 12px;
               font-size: 14px;
            }
         }
      }
   }

   .page-content {
      flex: 1;
      min-width: 0;
      border-left: 1px solid #e5e5e5;
      padding-left: 64px;

      @media (max-width: 1024px) {
         border-left: none;
         padding-left: 0;
      }

      @media (max-width: 768px) {
         width: 100%;
         padding-left: 0;
         border-left: none;
      }

      .privacy-section {
         margin-bottom: 48px;

         &:last-child {
            margin-bottom: 0;
         }

         h2 {
            font-size: 24px;
            font-weight: 600;
            color: #222222;
            margin: 0 0 24px 0;
            line-height: 1.3;
            padding: 10px 1rem;
            background: #fafafa;
            border-radius: 8px;
            margin-left: -1rem;

            @media (min-width: 768px) {
               font-size: 28px;
            }
         }

         h3 {
            font-size: 19px;
            font-weight: 600;
            color: #222222;
            margin: 32px 0 16px;
            line-height: 1.4;
            padding: 0.125rem 1rem;
            background: #f6f6f6;
            background: #2f64b909;
            // color: #fff;
            // color: #2f64b9;
            border-radius: 8px;
            margin-left: -1rem;
            margin-top: 3rem;

            &:first-of-type {
               margin-top: 0;
            }

            @media (min-width: 768px) {
               font-size: 22px;
            }
         }

         h4 {
            font-size: 17px;
            font-weight: 600;
            color: #222222;
            // color: #2f64b9;

            margin: 24px 0 12px;

            line-height: 1.4;

            &:first-of-type {
               margin-top: 0;
            }

            @media (min-width: 768px) {
               font-size: 18px;
            }
         }

         p {
            color: #222222;
            // color: #6a6a6a;
            font-size: 16px;
            line-height: 1.6;
            margin-bottom: 16px;
            font-weight: 400;

            &:last-child {
               margin-bottom: 0;
            }

            a {
               color: #2f64b9;
               text-decoration: underline;

               &:hover {
                  color: #000000;
               }
            }
         }

         ul {
            color: #222222;
            font-size: 16px;
            line-height: 1.6;
            margin-bottom: 16px;
            padding-left: 24px;
            list-style: none;
            counter-reset: list-counter;

            li {
               margin-bottom: 8px;
               counter-increment: list-counter;
               position: relative;
               padding-left: 8px;

               &:before {
                  content: "(" counter(list-counter) ")";
                  position: absolute;
                  left: -24px;
                  color: #717171;
               }

               &:last-child {
                  margin-bottom: 0;
               }
            }
         }
      }
   }
}
</style>
